import { Components } from '@mui/material'

export function OverridedDialog(): Components {
  return {
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiDialog-paper': {
            outline: 'none',
          },
          '& > .MuiDialog-container > .MuiPaper-root': {
            borderRadius: 16,
          },
        },
      },
    },
  }
}
